export const ONE_MINUTE = 60 * 1000;
export const ONE_DAY = 24 * 60 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;